import template from './ios-in-app.html';
import './ios-in-app.scss';

import bowser from 'bowser';

export default angular
  .module('doxy.unsupportedBrowserIosInApp', [])
  .component('unsupportedBrowserIosInApp', {
    template,
    controller: function () {
      this.url = window.location.href;
    },
  }).name;
